import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Authorization } from "../../Context/Authorization";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import { logActivity } from "../../utils/LogActivity";
import Preloader from "../../shared/PreLoaders";

const ViewEcoTourism = () => {
  const Api = process.env.REACT_APP_API;
  const navigate = useNavigate();
  const [ecoTourisms, setEcoTourisms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { userId } = useContext(AuthContext);

  useEffect(() => {
    fetchEcoTourisms();
  }, []);

  const fetchEcoTourisms = async () => {
    try {
      setLoading(true);
      const config = Authorization();
      const res = await axios.get(`${Api}/api/eco-tourism`, config);
      setEcoTourisms(res.data.data || []);
      await logActivity(userId, "Viewed Eco Tourism", "View Eco Tourism Page", Api);
      setError("");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Failed to load Eco Tourism data");
    } finally {
      setLoading(false);
    }
  };

  const handleEditEcoTourism = (id) => { navigate(`edit/${id}`); };

  const handleDeleteEcoTourism = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Eco Tourism?")) return;
    try {
      const Config = Authorization();
      await axios.delete(`${Api}/api/eco-tourism/${id}`, Config);
      setEcoTourisms(ecoTourisms.filter((eco) => eco._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting Eco Tourism", err);
      toast.error("Failed to delete Eco Tourism");
    }
  };

  const thStyle = { padding: "10px 12px", fontSize: 12, fontWeight: 700, color: "#2D3748", background: "#F7FAFC", border: "1px solid #E2E8F0", textAlign: "left" };
  const tdStyle = { padding: "9px 12px", fontSize: 12, color: "#4A5568", border: "1px solid #E2E8F0" };

  return (
    <div>
      {loading && <Preloader loading={loading} />}

      {/* ── Page Header ── */}
      <div style={{ marginBottom: 20 }}>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#1A202C", fontSize: 18 }}>Eco Tourism</h4>
        <div style={{ fontSize: 12, color: "#718096", marginTop: 3 }}>
          <span style={{ color: "#A0AEC0" }}>JFMC</span>
          <span style={{ margin: "0 6px", color: "#CBD5E0" }}>›</span>
          <span style={{ color: "#2E7D32", fontWeight: 600 }}>View Eco Tourism</span>
        </div>
      </div>

      {error && (
        <div style={{ marginBottom: 16, padding: "10px 14px", background: "#FFF5F5", border: "1px solid #FED7D7", borderRadius: 8, fontSize: 12, color: "#E53E3E", fontWeight: 600 }}>
          {error}
        </div>
      )}

      {/* ── Table Card ── */}
      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0", boxShadow: "0 1px 4px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "linear-gradient(135deg,#1B5E20,#2E7D32)" }}>
          <span style={{ width: 30, height: 30, background: "rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 15 }}>
            <i className="mdi mdi-pine-tree" />
          </span>
          <span style={{ fontSize: 13, fontWeight: 700, color: "#fff", flex: 1 }}>Eco Tourism List</span>
          <span style={{ padding: "3px 10px", background: "rgba(255,255,255,0.2)", borderRadius: 20, fontSize: 11, color: "#fff", fontWeight: 600 }}>
            {ecoTourisms.length} Records
          </span>
        </div>

        <div style={{ padding: 16, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Eco Name</th>
                <th style={thStyle}>Location</th>
                <th style={thStyle}>Range</th>
                <th style={thStyle}>Division</th>
                <th style={thStyle}>JFMC Type</th>
                <th style={thStyle}>VFC</th>
                <th style={thStyle}>Bank</th>
                <th style={thStyle}>Account No</th>
                <th style={thStyle}>IFSC</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {ecoTourisms.length === 0 ? (
                <tr>
                  <td colSpan={10} style={{ ...tdStyle, textAlign: "center", color: "#A0AEC0", padding: "40px" }}>
                    No Eco Tourism records found.
                  </td>
                </tr>
              ) : (
                ecoTourisms.map((eco, index) => (
                  <tr key={eco._id} style={{ background: index % 2 === 0 ? "#fff" : "#F7FAFC" }}>
                    <td style={tdStyle}>{index + 1}</td>
                    <td style={{ ...tdStyle, fontWeight: 600, color: "#2D3748" }}>{eco.ecoTourismName}</td>
                    <td style={tdStyle}>{eco.ecoTourismLocation}</td>
                    <td style={tdStyle}>{eco.rangeId?.rangeName}</td>
                    <td style={tdStyle}>{eco.rangeId?.divisionId?.divisionName}</td>
                    <td style={tdStyle}>{eco.jfmcType?.jfmcTypeName}</td>
                    <td style={tdStyle}>{eco.vfcId?.vfcName}</td>
                    <td style={tdStyle}>{eco.bankName}</td>
                    <td style={tdStyle}>{eco.accountNumber}</td>
                    <td style={tdStyle}>{eco.ifscCode}</td>
                    <td style={tdStyle}>
                      <i className="mdi mdi-pen" style={{ fontSize: "1.4rem", cursor: "pointer", marginRight: 8, color: "#2E7D32" }}
                        onClick={() => handleEditEcoTourism(eco._id)} />
                      <i className="mdi mdi-delete" style={{ fontSize: "1.4rem", cursor: "pointer", color: "#E53E3E" }}
                        onClick={() => handleDeleteEcoTourism(eco._id)} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ViewEcoTourism;
